import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var LayoutService = /** @class */ (function () {
    function LayoutService() {
        this.preloaderStateSource = new Subject();
        this.preloaderState$ = this.preloaderStateSource.asObservable();
    }
    LayoutService.prototype.updatePreloaderState = function (state) {
        console.log('preloader state: ' + state);
        this.preloaderStateSource.next(state);
    };
    LayoutService.ngInjectableDef = i0.defineInjectable({ factory: function LayoutService_Factory() { return new LayoutService(); }, token: LayoutService, providedIn: "root" });
    return LayoutService;
}());
export { LayoutService };
